import React, { useState } from "react";
import Auth from "../../utils/auth";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../../assets/logo-logout.svg'
import google_play from '../../assets/icon-google-play.svg'
import play_store from '../../assets/icon-play-store.svg'
import mockup from '../../assets/mobile-mockup.png'
import mobile from '../../assets/mobile.svg'
import check from '../../assets/tick-circle-green.svg'
import useExternalScripts from "../../hooks/useExternalScripts";
import { Link, useLocation } from "react-router-dom";
import crown from "../../assets/crown.svg"
import { FETCH_USER } from "../../utils/queries";
import { useQuery } from "@apollo/client";
import { Modal, NavDropdown } from "react-bootstrap";


function Header() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { loading, error, data } = useQuery(FETCH_USER, {
    fetchPolicy: 'network-only',
    skip: !Auth.loggedIn()
  });
  const location = useLocation();
  const user = data?.fetchUser;
  const date = user?.subscriptionExpiry
  const expiryDate = new Date(date).toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"long", day:"numeric"})
  useExternalScripts("https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image&async=true")
  function showNavigation() {
    if (Auth.loggedIn()) {
      return(
        <>
          <header>
            <Navbar className="navbar-mobile py-2 border-bottom" expand="xl" bg="white" variant="light">
              <Link className="navbar-brand py-0" to="/"><img src={logo} alt="" width={250} className="img-fluid" /></Link>
              <Navbar.Toggle aria-controls="basic-navbar-nav" className="rounded-0" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ms-auto d-flex align-items-start mt-2 mt-lg-0">
                <button type="button" className="me-3 mb-1 mb-xl-0 d-flex align-items-center btn btn-light border text-primary text-nowrap" onClick={()=>handleShow()}>
                    <img src={mobile} alt="Upgrade" width={20} className="me-2" />
                    Download Vocab App
                  </button>
                  <Link className="d-flex align-items-center btn btn-light border text-primary text-nowrap" to="/pricing">
                    <img src={crown} alt="Upgrade" width={20} className="me-2" />
                    {
                      (!loading && !error && user?.subscriptionStatus !== 'subscribed') ?
                        ('Upgrade')
                      :
                        ('Extend Plan')
                    }
                  </Link>
                  <Link className={`nav-link${location.pathname === '/dashboard' ? ' active':''}`} to="/dashboard">Dashboard</Link>
                  <Link className={`nav-link${location.pathname === ('/textbook') ? ' active':''}`} to="/textbook">Textbook</Link>
                  <Link className={`nav-link${location.pathname.indexOf("/mock") === 0 ? ' active':''}`} to="/mocks">Mocks</Link>
                  <Link className={`nav-link text-nowrap${location.pathname.indexOf("/practice-set") === 0 ? ' active':''}`} to="/practice-sets">Practice Sets</Link>
                  <NavDropdown title={user?.fullName} id="basic-nav-dropdown" align="end">
                    <Link className="dropdown-item" to='/profile'>Settings</Link>
                    <Link className="dropdown-item" onClick={() => Auth.logout()}>Logout</Link>
                  </NavDropdown>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
            { user?.subscriptionStatus === 'subscribed' && location.pathname === ('/dashboard' || '/') &&
              <div className="top-message">Your plan will expire on {expiryDate}. If you'd like to extend your membership, please <Link to="/pricing" className="underline">purchase</Link> another plan.</div>
            }
            { location.pathname === ('/dashboard' || '/') &&
              <div className="top-message-success">Now updated for the new GRE!</div>
            }
          </header>
          <Modal show={show} onHide={handleClose} className="app-modal" centered={true}>
        
            <Modal.Body className="p-0 py-0">
            <Modal.Header closeButton className="px-0"></Modal.Header>
              <div className="row">
              <div className="col-md-6 text-center text-md-left">
                <div className="left-colomun pt-5 pt-md-4 pb-0">
                  <img src={mockup} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6 pb-3 px-4">
              <h3 className="fs-32 mt-5">Learn Vocab 5x Faster</h3>
                <p className="fs-12 mb-3">Accelerate your progress with "semantic clusters," groups of words of similar meaning associated with a simplified definition. Practice the skill you will actually use on test day.</p>
                <div className="d-flex mb-2 align-items-center">
                  <img src={check} alt="tick" className="me-3" />
                  <p className="fs-14 fw-medium">1500+ GRE words</p>
                </div>
                <div className="d-flex mb-2 align-items-center">
                  <img src={check} alt="tick" className="me-3" />
                  <p className="fs-14 fw-medium">Adaptive presentation</p>
                </div>
                <div className="d-flex mb-2 align-items-center">
                  <img src={check} alt="tick" className="me-3" />
                  <p className="fs-14 fw-medium">Unlimited quiz questions</p>
                </div>
                <p className="fs-16 fw-medium mt-4 mb-3">Download the app today</p>
                <a href="https://play.google.com/store/apps/details?id=co.systemplus.stellargre&amp;pli=1" target="_blank" rel="noreferrer" >
                  <img src={google_play} className="me-2 mb-2" width={113} alt="" />
                </a>
                <a href="http://apps.apple.com/us/app/stellargre-vocab-flashcards/id1668110596" target="_blank" rel="noreferrer">
                  <img src={play_store} className="mb-2" width={113} alt="" />
                </a>
              </div>
              <div>
              

                </div>
                
              </div>
            </Modal.Body>
          
          </Modal>

        </>
      )
    }
  }
  return (
    showNavigation()
  );
}

export default Header;